
## Budowa komputera

Uproszczony schemat
<img src={new URL('../../img/teoria/komputer_urzadzenia.png', import.meta.url)} alt="xyz" className={`big_img`} />
